import { ChangeDetectorRef, Component, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { TextInputDataComponent } from '../../../components/text-input/text-input.component';
import { SelectComponent } from '../../../components/select/select.component';
import { HandleBookingService } from '../../../services/handle-booking.service';
import { RadioBtnComponent } from '../../../components/radio-btn/radio-btn.component';
import { ParkingRepo } from '../../../repo/parking.repo';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { EmailInputFieldComponent } from '../../../components/email-input-field/email-input-field.component';
import { PhoneNumberInputComponent } from '../../../components/phone-number-input/phone-number-input.component';
import { CommonModule } from '@angular/common';
import { FormService } from '../../../organizations/features/booking/components/form/service';
import { MatDialog } from '@angular/material/dialog';
import { BookingSummaryCardComponent } from '../../../components/booking-summary-card/booking-summary-card.component';
import { BookingConfigService } from '../../../services/booking-config.service';
import { FormGroup } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { BASE64_FLYGETS_LOGO } from '../../../../../assets/base64-logos/flygets-logo';
import { BASE64_SKAVSTA_LOGO } from '../../../../../assets/base64-logos/skavsta-logo';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { BackOfficeService } from '../../../../services/backoffice.service';
import { DatePickerModalComponent } from '../../../components/datepicker-modal/datepicker-modal.component';
import { FlightPickerModalComponent } from '../../../../../app/parkifly-bookings/flightpicker-modal/flightpicker-modal.component';
import { ModalSimpleDatetimeComponent } from '../../../components/modal-simple-datetime/modal-simple-datetime.component';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, of, throwError, timeout } from 'rxjs';
import { CartService } from '../../../../../app/services/cart.service';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { TranslateAttributePipe } from '../../../../../app/pipes/translate-attribute/translate-attribute.pipe';

@Component({
  selector: 'app-update-booking-simple',
  imports: [
    RouterLink,
    TextInputDataComponent,
    SelectComponent,
    RadioBtnComponent,
    TranslocoModule,
    EmailInputFieldComponent,
    PhoneNumberInputComponent,
    CommonModule,
    BookingSummaryCardComponent,
    MatProgressBarModule,
    MatListModule,
    MatIconModule,
    MatFormFieldModule,
    MatButtonModule,
    MatLabel,
    MatCheckboxModule,
    TranslateAttributePipe
  ],
  templateUrl: './update-booking-simple.component.html',
  styleUrl: './update-booking-simple.component.css',
  changeDetection: ChangeDetectionStrategy.Eager,
  providers: [HandleBookingService]
})

export class UpdateBookingSimpleComponent {

  handleBookingStatus: 'error' | 'updated' | '' = '';
  handleBookingGroup: any;
  email: string | null = "";
  bookingNumber: string | null = "";
  // arrivalParkingOptions = [
  //   { value: '', viewValue: '' },
  // ];
  parkingFrom: any;
  site: string = ""
  booking: any = null;
  checkInBagage: any = []
  additionalServices: any;
  orderId: any = null;
  parkType: string = '';
  freeShuttles: boolean = false;
  bookingDetails: any = {
    order: null,
    parking: null,
    shuttles: [],
    additionalServices: []
  };
  form !: FormService;
  parkingType!: string;
  details !: FormGroup;
  parkingGroup: any;
  departureHotel: any;
  arrivalHotel: any;
  bookingLoaded: boolean = false;
  activeLang: string = 'sv';
  officeAddress: string = 'Matchedin AB, org.nr: 559013-7716 Wallingatan 42, 111 24 Stockholm';
  isLoading: boolean = false;
  parkingNames: any = {
    "677844ae-bb01-4265-bfde-32264410ed09": 'P_49',
    "453f945a-ee11-4d75-8265-b16f00e5f04b": 'P_41',
    "f9e5d6c3-4419-4c61-a290-b16f00e5e500": 'P_40',
    "8c98315a-b2ad-4e70-86f9-5d54992fed26": 'P_39',
    "697844ae-bb01-4265-bfde-32264410ed09": 'P_67',
    "c797769e-66bf-4283-96c5-b16f00e5e126": 'P_1',
    "eacc8615-81a4-4013-a7e5-b16f00e5e270": 'P_6',
    "1a8879f4-a294-455b-97eb-b16f00e5e30a": 'P_12',
    "5d2c7728-6944-45a6-a64e-b16f00e5e3b3": 'P_18',
    "8d922482-7855-47dc-953b-b16f00e5e45a": 'P_24'
  }
  base64FlygetsLogo = BASE64_FLYGETS_LOGO;
  base64SkavstaLogo = BASE64_SKAVSTA_LOGO;
  organizationId: string = 'A848CCD3-FD8D-4035-925E-571EBB4E93E8';
  allAdditionalServices: any = [];
  isEditable: boolean = false;
  formHasChanges = false;
  isInitializing = true;
  hasSpecialParams: boolean = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private handleBookingService: HandleBookingService,
    private parkingRepo: ParkingRepo,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private translocoService: TranslocoService,
    private bookingConfigService: BookingConfigService,
    private _formService: FormService,
    public backofficeService: BackOfficeService,
    public translate: TranslocoService
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
  }

  public ngOnInit() {
    this.isLoading = true;
    this.getPreservedQueryParams();
    this.activeLang = this.translocoService.getActiveLang();
    this.translocoService.langChanges$.subscribe((lang) => {
      this.activeLang = lang;
    });
    this.translocoService.selectTranslate('PARKIFLY.PLACEHOLDER.1_HOUR_BEFORE')
      .subscribe(value => {
        this.checkInBagage = [
          { value: '1', viewValue: this.translocoService.translate("PARKIFLYFORM.YES") },
          { value: '0', viewValue: this.translocoService.translate("PARKIFLY.SUMMARY.ONLY_CARRYON_LUGGAGE_OPTION") },
        ]
      });

    this.route.paramMap.subscribe(params => {
      this.email = params.get("email");
      this.bookingNumber = params.get("booking_number");
      if (this.email && this.bookingNumber) {
        this.handleBookingService.getBookingDetails(this.email, this.bookingNumber).subscribe(
          {
            next: ((bookingDetails) => {

              this.site = bookingDetails.organizationName?.toLowerCase();
              if (this.site == "flygets.se") {
                this.site = "flygets";
              }
              if (this.site == "tui" || this.site == "nazar" || this.site == "ving") {
                this.site = "flygets";
              }
              if (this.site == "quality hotel arlanda xpo parkering" || this.site == "quality-xpo-arlanda" || this.site == "quality") {
                this.site = "quality-xpo-arlanda";
              }
              if (this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.site = "aiden-short-term";
              }

              this.bookingConfigService.setOrganization(this.site);
              this.handleBookingService.initForm(this.site);
              this._formService.initForm(this.site);

              this.handleBookingGroup = this.handleBookingService.getForm().get('details');

              setTimeout(() => {
                this.isInitializing = false;
              }, 1000);

              this.handleBookingGroup.valueChanges.subscribe(() => {
                if (!this.isInitializing) {
                  this.formHasChanges = true;
                }
              });

              this.parkingType = this._formService.selectedParking;
              this.form = this._formService;
              this.details = this.form.getForm().get('details');
              this.parkingGroup = this.form.getForm().get('parkingGroup');
              this.departureHotel = this.form.departureHotel || this.form.getForm().get('hotels')?.controls.departureHotel.value;
              this.arrivalHotel = this.form.arrivalHotel || this.form.getForm().get('hotels')?.controls.arrivalHotel.value;

              if (bookingDetails.orderStatus == "Cancelled") {
                this.routerNavigatePreservingParams(['/parkifly/handle-booking']);
              }
              this.orderId = bookingDetails.orderId;
              this.booking = bookingDetails;

              if (this.booking != null) {
                setTimeout(() => {
                  this.bookingLoaded = true;
                }, 1000);
              }

              this.handleBookingService.getForm().get('details').controls['cellular'].setValue(bookingDetails.cellular ?? '');
              this.handleBookingService.getForm().get('details').controls['regNr'].setValue(bookingDetails.carRegNumber ?? '');
              if (bookingDetails.parkingStatus === 'Checkin' || bookingDetails.parkingStatus === 'Checkout') {
                this.handleBookingService.getForm().get('details').controls['regNr'].disable();
              }
              this.handleBookingService.getForm().get('details').controls['email'].setValue(bookingDetails.email ?? '');
              this.handleBookingService.getForm().get('details').controls['email'].disable();
              if (this.site === 'skavsta' || this.site === 'quality hotel arlanda xpo parkering' || this.site === 'quality-xpo-arlanda' || this.site === 'quality' || this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
                this.handleBookingService.getForm().get('details').controls['firstname'].setValue(bookingDetails.firstName ?? '');
                this.handleBookingService.getForm().get('details').controls['firstname'].disable();
                this.handleBookingService.getForm().get('details').controls['lastname'].setValue(bookingDetails.lastName ?? '');
                this.handleBookingService.getForm().get('details').controls['lastname'].disable();
                this.handleBookingService.getForm().get('details').controls['persons']?.setValue(bookingDetails?.passengers?.toString());
                this.booking.parkingShuttleFrom = bookingDetails.parkingFrom;
                this.booking.parkingShuttleTo = bookingDetails.parkingTo;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
              }
              if (this.site === 'flygets') {
                this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
                this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFrom;
                // this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
                this.parkingFrom = new Date(this.parkingFrom);
                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(currentParkingTime);

                const additionalServicesArray = bookingDetails?.additionalServices?.length > 0
                  ? bookingDetails.additionalServices.filter((e: any) => (e.status != 'Cancelled' && e.status != 'Removed'))
                  : [];
                if (additionalServicesArray.length > 0) {
                  additionalServicesArray.forEach(function (element: any, index: any) {
                    if (typeof element.name === 'string') {
                      element.name = JSON.parse(element.name);
                    }
                    if (typeof element.description === 'string') {
                      element.description = JSON.parse(element.description);
                    }
                    if (element.amount && element.vatAmount) {
                      element.amount = element.amount + element.vatAmount;
                    }
                  });
                }
                this.bookingDetails.additionalServices = additionalServicesArray;
                this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
              }
              if (this.site === 'mdpark') {
                this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
                this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
                this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
                this.parkingFrom = bookingDetails.parkingFrom;
                // this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
                this.parkingFrom = new Date(this.parkingFrom);
                var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
                var currentParkingTime = (
                  parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
                  (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
                  );
                this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(currentParkingTime);
              }
              this.isLoading = false;
            })
          }
        );
      } else {
        this.routerNavigatePreservingParams(['/parkifly/handle-booking']);
      }
    });
  }

  updateBooking() {
    this.isLoading = true;
    const form = this.handleBookingService.getForm().value;
    var updates;

    if (this.site === 'flygets') {
      var timeFromForm = form.details.arrivalTimeAtParking;
      var hoursFromForm = timeFromForm.charAt(0) == 0 ? timeFromForm.substring(1, 2) : timeFromForm.substring(0, 2);
      var minutesFromForm = timeFromForm.charAt(3) == 0 ? timeFromForm.substring(4) : timeFromForm.substring(3);
      var newParkingFrom = new Date(this.parkingFrom);
      newParkingFrom.setHours(hoursFromForm, minutesFromForm)
      if (this.parkingFrom < newParkingFrom) {
        newParkingFrom.setDate(newParkingFrom.getDate() - 1);
      }
      updates = {
        orderNumber: this.bookingNumber ? this.bookingNumber : '',
        email: this.email ? this.email : '',
        cellular: form.details.cellular,
        comment: form.details.comment,
        carRegNumber: this.handleBookingGroup.controls['regNr'].value,
        passengers: form.details.persons,
        contact: form.details.contact ? (form.details.contact == 'true' ? true : false) : false,
        newParkingFrom: this.normalizeISOString(newParkingFrom),
      }
    }
    else if (this.site === 'mdpark') {
      var timeFromForm = form.details.arrivalTimeAtParking;
      var hoursFromForm = timeFromForm.charAt(0) == 0 ? timeFromForm.substring(1, 2) : timeFromForm.substring(0, 2);
      var minutesFromForm = timeFromForm.charAt(3) == 0 ? timeFromForm.substring(4) : timeFromForm.substring(3);
      var newParkingFrom = new Date(this.parkingFrom);
      newParkingFrom.setHours(hoursFromForm, minutesFromForm)
      if (this.parkingFrom < newParkingFrom) {
        newParkingFrom.setDate(newParkingFrom.getDate() - 1);
      }
      updates = {
        orderNumber: this.bookingNumber ? this.bookingNumber : '',
        email: this.email ? this.email : '',
        cellular: form.details.cellular,
        comment: form.details.comment,
        carRegNumber: this.handleBookingGroup.controls['regNr'].value,
        passengers: form.details.persons,
        contact: form.details.contact ? (form.details.contact == 'true' ? true : false) : false,
        newParkingFrom: this.normalizeISOString(newParkingFrom),
      }
    }
    else if (this.site === 'skavsta' || this.site === 'quality hotel arlanda xpo parkering' || this.site === 'quality-xpo-arlanda' || this.site === 'quality' || this.site == "aiden hotel arlanda parkering" || this.site == "aiden-short-term" || this.site == "aiden") {
      updates = {
        orderNumber: this.bookingNumber ? this.bookingNumber : '',
        email: this.email ? this.email : '',
        cellular: form.details.cellular,
        carRegNumber: this.handleBookingGroup.controls['regNr'].value,
        newParkingFrom: this.booking.parkingFrom,
        passengers: form.details.persons
      }
    }

    this.handleBookingService.updateBookingDetails(updates).subscribe(result => {
      this.isLoading = false;
      this.formHasChanges = false;
      this.handleBookingGroup.markAsPristine();
      const message = this.translate.translate('HANDLE_BOOKING.UPDATE_BOOKING');
      this._snackBar.open(message, 'OK', {
        duration: 3000,
        verticalPosition: 'top',
        horizontalPosition: 'center'
      });
      // if (this.site === 'flygets' || this.site === 'tui' || this.site === 'nazar') {
      //   if (this.booking?.parkingStatus === 'Checkin' && this.booking?.additionalServices?.length <= 0) {
      //     this.routerNavigatePreservingParams(['/parkifly/booking-overview', { email: this.email, booking_number: this.bookingNumber }]);
      //   } else {
      //     this.routerNavigatePreservingParams(['parkifly/edit-parking-additional-services', { email: this.email, booking_number: this.bookingNumber }]);
      //   }
      // } else {
      this.routerNavigatePreservingParams(['/parkifly/booking-overview', { email: this.email, booking_number: this.bookingNumber }]);
      // }
    });
  }

  regToUpper() {
    this.handleBookingGroup.controls["regNr"].setValue(this.handleBookingGroup.controls["regNr"]._pendingValue.toUpperCase());
  }

  goToPaymentPage() {
    this.routerNavigatePreservingParams(['parkifly', this.site, 'checkout', 'payment', this.orderId]);
  }

  goBack() {
    this.routerNavigatePreservingParams(['parkifly/booking-overview', { email: this.email, booking_number: this.bookingNumber }]);
  }

  normalizeISOString(date: Date): string {
    const pad = (n: number) => String(n).padStart(2, '0');
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}T${pad(date.getHours())}:${pad(date.getMinutes())}:${pad(date.getSeconds())}`;
  }

  private getPreservedQueryParams(): Record<string, string> {
    const params = this.route.snapshot.queryParamMap;
    const queryParams: Record<string, string> = {};
    const lang = params.get('lang');
    const mobile = params.get('mobile');

    if (lang) {
      queryParams.lang = lang;
    }
    if (mobile) {
      queryParams.mobile = mobile;
    }

    this.hasSpecialParams = !!(lang || mobile);

    return queryParams;
  }

  private routerNavigatePreservingParams(commands: any[], extras: Record<string, any> = {}) {
    const preserved = this.getPreservedQueryParams();
    const mergedQueryParams = {
      ...(extras.queryParams || {}),
      ...preserved
    };

    if (Object.keys(mergedQueryParams).length > 0) {
      extras = { ...extras, queryParams: mergedQueryParams };
    }

    this.router.navigate(commands, extras);
  }

}